import React, { FC } from 'react';
import { isValidURL } from '../utils';

interface AuthorProps {
  name: string;
  url: string;
  isInsider: boolean;
  insiderTeam: string;
}

const Author: FC<AuthorProps> = ({
  name,
  url,
  isInsider,
  insiderTeam,
}) => (
  isValidURL(url) ? <a href={url}>{name}{isInsider && '' !== insiderTeam ? `, ${insiderTeam}` : ''}</a>
    : <span>{name}{isInsider && '' !== insiderTeam ? `, ${insiderTeam}` : ''}</span>
);

export default Author;
